import { Link } from "react-router-dom";
import { MdOutlineDesignServices } from "react-icons/md";
import { RiCustomerService2Line, RiSettings3Line } from "react-icons/ri";
import { FaScrewdriverWrench } from "react-icons/fa6";

const SERVICES = [
  {
    slug: "av-design",
    title: "Desain Sistem Audiovisual",
    icon: MdOutlineDesignServices,
    desc:
      "Desain sistem AV kami meliputi pemetaan perangkat, jalur topologi, serta desain implementasi pada lokasi yang presisi sehingga memastikan hasil akhir yang fungsional dan andal.",
    points: ["Survei Lokasi", "Skema Alur & Tata Letak", "Daftar Kebutuhan Perangkat"],
  },
  {
    slug: "service-center",
    title: "Service Center",
    icon: RiCustomerService2Line,
    desc:
      "Kami percaya kualitas layanan tidak berhenti setelah instalasi. Dengan pusat servis yang terintegrasi Anda akan mendapatkan pemeliharan perangkat secara berkala serta dukungan teknisi bersertifikat kapanpun anda butuhkan.",
    points: ["Pelatihan Penggunaan Perangkat", "Pemeliharaan Perangkat", "Dukungan melalui Jarak Jauh maupun langsung di Lokasi"],
  },
  {
    slug: "installasi",
    title: "Installasi",
    icon: FaScrewdriverWrench,
    desc:
      "Instalasi dilakukan dengan standar industri, penataan kabel yang rapi, serta proses pengecekan yang menyeluruh sehingga menghasilkan sistem audiovisual yang akan berjalan dengan aman stabil dan optimal",
    points: ["Pemasangan Perangkat & Penataan Kabel Rapi", "Pengujian & Pengecekan Sistem", "Pelatihan Operator"],
  },
  {
    slug: "product-customize",
    title: "Product Customize",
    icon: RiSettings3Line,
    desc:
      "Setiap perusahaan memiliki spesifiknya masing - masing. Kami menawarkan kustomisasi perangkat dan antarmuka kontrol agar workflow lebih efisien, serta desain yang selaras dengan Intervace Control Anda.",
    points: ["Tampilan Antarmuka yang sesuai dengan identitas perusahaan anda", "Integrasi Dengan API atau Driver Sistem Lain", "Penyesuaian Workflow Operasional"],
  },
];

export default function ServiceList() {
  return (
    <main className="bg-[#F3F3F3] text-[#0B132A]">
      <section
        className="relative overflow-hidden bg-center bg-cover"
        style={{ backgroundImage: "url('/images/services/bg-serv2.png')" }}
      >
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative max-w-7xl mx-auto px-6 sm:px-6 md:px-10 xl:px-20 py-8 md:py-12 text-white">
          <p className="text-emerald-400 font-semibold tracking-wide">Layanan Kami</p>
          <h1 className="mt-2 text-3xl md:text-5xl font-semibold tracking-tight">
            Distributor & Service Audiovisual Terpercaya
          </h1>
          <p className="mt-4 max-w-2xl text-gray-200">
            Sebagai distributor perangkat audiovisual kami menyediakan produk berkualitas tinggi untuk
            berbagai kebutuhan anda. Kami juga menawarkan layanan instalasi dan perbaikan profesional,
            dengan komitmen untuk memenuhi standar tertinggi dan memastikan kepuasan pelanggan dalam setiap
            layanan yang kami berikan. 
          </p>
        </div>
      </section>

      <section className="mt-12 pb-20 md:pb-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10 xl:px-20">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {SERVICES.map((s, i) => {
              const Icon = s.icon;
              return (
                <Link
                  key={s.slug}
                  to={`/services/${s.slug}`}
                  className="group relative rounded-2xl p-px
                             bg-gradient-to-br from-emerald-400/30 via-transparent to-cyan-400/30
                             transition-transform"
                  data-aos="fade-up"
                  data-aos-duration="800"
                  data-aos-delay={i * 120}
                  aria-label={`Buka ${s.title}`}
                >
                  <div
                    className="h-full rounded-2xl bg-white border border-gray-200
                               shadow-sm transition-all duration-300
                               group-hover:shadow-2xl group-hover:-translate-y-1"
                  >
                    <div className="p-6">
                      <div
                        className="inline-flex h-12 w-12 items-center justify-center rounded-xl
                                   bg-emerald-50 text-emerald-600 ring-1 ring-emerald-100
                                   transition-all duration-300 group-hover:scale-110 group-hover:rotate-3"
                      >
                        <Icon className="text-2xl" />
                      </div>

                      <h3 className="mt-4 text-xl font-semibold">{s.title}</h3>
                      <p className="mt-2 text-sm text-gray-600">{s.desc}</p>

                      <ul className="mt-4 space-y-2">
                        {s.points.map((p, idx) => (
                          <li key={idx} className="flex items-start gap-2 text-sm text-gray-700">
                            <span className="mt-1 inline-block h-1.5 w-1.5 rounded-full bg-emerald-500" />
                            <span>{p}</span>
                          </li>
                        ))}
                      </ul>

                      <div className="mt-6 flex items-center gap-2">
                        <span className="text-emerald-700 font-medium">Pelajari lebih lanjut</span>
                        <svg
                          className="h-4 w-4 translate-x-0 opacity-60 transition-all duration-300 group-hover:translate-x-1 group-hover:opacity-100"
                          viewBox="0 0 24 24"
                          fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        >
                          <path d="M5 12h14" /><path d="m12 5 7 7-7 7" />
                        </svg>
                      </div>
                      <span
                        className="mt-2 block h-[2px] w-0 bg-gradient-to-r from-emerald-500 to-cyan-500
                                   transition-all duration-300 group-hover:w-24"
                      />
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </main>
  );
}
